import http from '@/utils/http';
import {
  getAgencyCouponUrl,
  getBillingHistoriesUrl,
  getBillingHistoryUrl,
  getCardDetailsUrl,
  getCardDetailUrl,
  getPayAgencyDuesUrl,
  getAgencyInvoiceTransactionsUrl,
  getFetchAgencyInvoiceUrl,
  getCancelAgencySubscriptionUrl
} from './apiUrls';
import { CardDetailsResponse, InvoiceTransactionResponse } from './types';
import type { CancelSubscriptionPayload } from '@/components/Common/CancelSubscription/types';

export function getBillingHistories(params?: Record<string, any>): Promise<any> {
  return http.get(getBillingHistoriesUrl(), params);
}

export function getBillingHistory(params?: Record<string, any>): Promise<any> {
  return http.get(getBillingHistoryUrl(), params);
}

export function getCardDetails(): Promise<CardDetailsResponse> {
  return http.get(getCardDetailsUrl());
}

export function updateCardDetail(id: string): Promise<CardDetailsResponse> {
  return http.patch(getCardDetailUrl(id));
}

export function deleteCardDetail(id: string): Promise<CardDetailsResponse> {
  return http.delete(getCardDetailUrl(id));
}

export function addCardDetails(params?: Record<string, any>): Promise<{ checkout_url: string }> {
  return http.post(getCardDetailsUrl(), params);
}

export function addAgencyCoupon(params: Record<string, any>): Promise<any> {
  return http.post(getAgencyCouponUrl(), params);
}

export function removeAgencyCoupon(params: Record<string, any>): Promise<any> {
  return http.delete(getAgencyCouponUrl(), params);
}

export function payAgencyDues(): Promise<any> {
  return http.post(getPayAgencyDuesUrl(), {});
}

export function getAgencyInvoiceTransactions(invoiceId: number): Promise<InvoiceTransactionResponse[]> {
  return http.get(getAgencyInvoiceTransactionsUrl(), { invoice_id: invoiceId });
}

export function fetchAgencyInvoice(id: number): Promise<{ url: string }> {
  return http.get(getFetchAgencyInvoiceUrl(id));
}

export function cancelAgencySubscription(payload?: CancelSubscriptionPayload): Promise<{ charged_amount?: number }> {
  return http.post(getCancelAgencySubscriptionUrl(), payload ?? {});
}
